/* src/app/features/renuncia/tarefas/tarefas.component.scss */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
.d-flex.title {
  padding-right: 750px;
  font-weight: bold;
}
/*# sourceMappingURL=tarefas.component.css.map */
